export default __webpack_public_path__ + "static/media/moodboard-milieu-souterrain.d981af5e.pdf";